import React from 'react';
import { AfterSubmitFunc, FormTemplate, TextInput, useShowContextRequired } from 'ui-builder';
import {
  ConnectionProfile,
  FubFieldMapEntry,
  FubFieldType,
  ProjectDetailsFieldType,
  ProjectType,
  useFubFieldsMappingService
} from 'nekst-api';
import { PerMarketFieldsDropdowns } from './PerMarketFieldsDropdowns';
import { FubFieldMappingListItem } from './types';

function useTypesHelper() {
  const showContext = useShowContextRequired<FubFieldMapEntry>();

  const getTypes = () => {
    switch (showContext.data.fubFieldType) {
      case FubFieldType.DATE:
        return [ProjectDetailsFieldType.DATE];
      case FubFieldType.NUMBER:
        return [ProjectDetailsFieldType.PRICE];
      default:
        return [ProjectDetailsFieldType.SHORT_TEXT, ProjectDetailsFieldType.LONG_TEXT];
    }
  }

  return {
    getTypes,
  }
}

export default function UpdateFieldMappingForm(props: {
  afterSubmitFunc?: AfterSubmitFunc,
  profile: ConnectionProfile,
  projectType: ProjectType,
}) {
  const showContext = useShowContextRequired<FubFieldMappingListItem>();

  const fieldsMappingService = useFubFieldsMappingService();

  const typesHelper = useTypesHelper();

  return (
    <FormTemplate<{
      detailsFieldId?: string,
      fubFieldId: string,
      fubFieldLabel: string
      mappings: {
        nekstFieldId?: string;
        setupAreaId: number;
      }[]
    }>
      submitFormFunc={async (data) => {
        await fieldsMappingService.updateMapEntries(
          props.profile.id,
          props.projectType,
          data.mappings.map((mappingEntry) => ({
            setupAreaId: mappingEntry.setupAreaId,
            fubFieldId: data.fubFieldId,
            nekstFieldId: mappingEntry.nekstFieldId,
          }))
        )

        return data;
      }}
      initialData={{
        fubFieldId: showContext.data.fubFieldId,
        fubFieldLabel: showContext.data.fubFieldLabel,
        mappings: showContext.data.mappings.map((item) => {
          return {
            nekstFieldId: item.nekstFieldId,
            setupAreaId: item.setupArea.id,
            setupAreaName: item.setupArea.name,
          };
        }),
      }}
      title="Update Follow Up Boss Field Mapping"
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <TextInput source="fubFieldLabel" label="Follow Up Boss Field" isDisabled />
      <PerMarketFieldsDropdowns
        projectType={props.projectType}
        types={typesHelper.getTypes()}
      />
    </FormTemplate>
  );
}
